import React from 'react';
import 'fontsource-roboto';
import clsx from 'clsx';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import Drawer from '@material-ui/core/Drawer';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import List from '@material-ui/core/List';
import CssBaseline from '@material-ui/core/CssBaseline';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import { BrowserRouter as Router, Route, Link} from 'react-router-dom';
import Tooltip from '@material-ui/core/Tooltip';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import Logout from './Logout';
import Inicio from './Inicio';
import Cookies from 'universal-cookie';
import BarChartIcon from '@material-ui/icons/BarChart';
import DashboardsEfecto from './components/dashboardsEfect';
import PopUpDescargar from './components/PopUpDescargar';
import PopUpCargar from './components/PopUpCargar';
import ReactNotification from 'react-notifications-component';
import 'react-notifications-component/dist/theme.css';
import PopUpCambiarContraseña from './components/PopUpCambiarContraseña';
import IndicadoresEconomicos from './components/Banxico';
import Banxico from './components/Banxico';
import Inegi from './components/Inegi';
import PopUpContacto from './components/Contacto';
import PopUpBorrarDatos from './components/BorrarDatos/PopUpBorrarDatos';
import PopUpActualizar from './components/Actualizar/PopUpActualuzar';
import './Login.css';

const cookies = new Cookies();
const drawerWidth = 240;
const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
    },
    nested: {
        paddingLeft: theme.spacing(4),
    },
    appBar: {
        zIndex: theme.zIndex.drawer + 1,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
    },
    appBarShift: {
        marginLeft: drawerWidth,
        width: `calc(100% - ${drawerWidth}px)`,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
     menuButton: {
        marginRight: 36,
         },
    hide: {
        display: 'none',
    },
    drawer: {
        width: drawerWidth,
        flexShrink: 0,
        whiteSpace: 'nowrap',
    },
    drawerOpen: {
        width: drawerWidth,
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    drawerClose: {
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        overflowX: 'hidden',
        width: theme.spacing(7) + 1,
        [theme.breakpoints.up('sm')]: {
            width: theme.spacing(9) + 1,
        },
    },
    toolbar: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        padding: theme.spacing(0, 1),
        // necessary for content to be below app bar
        ...theme.mixins.toolbar,
    },
    content: {
        flexGrow: 1,
        padding: theme.spacing(3),
    },

    title: {
        marginRight:80,
    },
    titleImg: {
        marginRight:20,
    },

    image:{
        width:12,
        height:12,
    },


   

}));

export default function MiniDrawer(props) {
    const classes = useStyles();
    const theme = useTheme();
    const [open, setOpen,] = React.useState(false);
    const R = "R";
    var operacion;
      if (cookies.get('Operacion')== R) {
          operacion=true
      } else{
          operacion=false
      }



    const handleDrawerOpen = () => {
        setOpen(true);
    };

    const handleDrawerClose = () => {
        setOpen(false);
    };

     return (
        <Router>
            <div className={classes.root}>
                <CssBaseline />
                <ReactNotification /> 
                <AppBar position="fixed" className={clsx(classes.appBar, { [classes.appBarShift]: open, })}>
                    
                    <Toolbar >
                        <IconButton color="inherit" aria-label="open drawer" onClick={handleDrawerOpen} edge="start" className={clsx(classes.menuButton, { [classes.hide]: open, })}>
                            <Tooltip title="Menu">
                                <MenuIcon/>
                            </Tooltip>
                        </IconButton>
                        <img  className="text-center img-fluid z-depth-0 App-logo" src={cookies.get('LogoCompania')} alt="" width="48" height="48" />
                        <Typography className={classes.title} variant="h6" noWrap>&nbsp;&nbsp;{cookies.get('NombreCompania')}</Typography>
                        <Typography variant="subtitle2" noWrap>Bienvenido: {cookies.get('Usuario')}</Typography>
                    </Toolbar>    
                    </AppBar>
                <Drawer
                    variant="permanent"
                    className={clsx(classes.drawer, {
                        [classes.drawerOpen]: open,
                        [classes.drawerClose]: !open,
                    })}
                    classes={{
                        paper: clsx({
                            [classes.drawerOpen]: open,
                            [classes.drawerClose]: !open,
                        }),
                    }}
                >
                    <div className={classes.toolbar}>
                        <IconButton onClick={handleDrawerClose}>
                            {theme.direction === 'rtl' ? <ChevronRightIcon /> :
                                <Tooltip title="close">
                                    <ChevronLeftIcon />
                                </Tooltip>
                            }
                        </IconButton>
                    </div>
                    <Divider />
                    <Divider />

                    <List> 
                        <ListItem button disabled={operacion}>
                            <Link to="/Dashboards" exact>
                                <Tooltip title="Dashboards">
                                    <ListItemIcon>                                       
                                       <img src='graph-bar.png'  alt="" width="25" height="25"/>                               
                                    </ListItemIcon>
                                </Tooltip>
                            </Link>
                             <ListItemText primary="Dashboards" />
                        </ListItem>

                        <ListItem button>                            
                            <ListItemIcon>
                                <Banxico/>
                            </ListItemIcon>
                                <ListItemText primary="Banxico" />                           
                        </ListItem>

                        <ListItem button>                           
                            <ListItemIcon>
                                <Inegi/>
                            </ListItemIcon>
                                 <ListItemText primary="Inegi" />                           
                        </ListItem>

                        <ListItem button disabled={operacion}>                            
                            <ListItemIcon>
                                <PopUpActualizar/>
                            </ListItemIcon>
                                <ListItemText primary="Actualizar Datos" />                           
                        </ListItem>

                        <ListItem button disabled={operacion}>                            
                            <ListItemIcon>
                                <PopUpCargar/>
                            </ListItemIcon>
                                <ListItemText primary="Cargar Archivo" />                           
                        </ListItem>

                        <ListItem button disabled={operacion}>                            
                            <ListItemIcon>
                                <PopUpBorrarDatos/>
                            </ListItemIcon>
                               <ListItemText primary="Borrar" />                           
                        </ListItem>

                        <ListItem button disabled={operacion}>                            
                            <ListItemIcon>
                                <PopUpDescargar/>                                      
                            </ListItemIcon>
                                <ListItemText primary="Descargar Archivo" />                            
                        </ListItem>

                        <ListItem button>                           
                                
                                    <ListItemIcon>
                                        <PopUpCambiarContraseña/>
                                    </ListItemIcon>
                                                    
                                <ListItemText primary="Cambiar Password" />
                        </ListItem>

                        <ListItem button>                           
                                <Tooltip title="Soporte Técnico">
                                    <ListItemIcon>
                                        <PopUpContacto/>
                                    </ListItemIcon>
                                </Tooltip>                       
                                <ListItemText primary="Soporte Técnico" />
                        </ListItem>

                         <ListItem button>
                            <Link to="/Logout" exact>
                                <Tooltip title="Logout">
                                    <ListItemIcon>
                                       {/* <ExitToAppIcon style={{ color:'#a54400' }}/> */}
                                        <img src='log-out.png' alt="" width="25" height="25"/>
                                    </ListItemIcon>
                                </Tooltip>
                            </Link>                          
                                <ListItemText primary="Logout" />                         
                        </ListItem>
                    </List>
                </Drawer>
                <main className={classes.content}>
                    <div className={classes.toolbar} />
                    <Typography paragraph>
                        <switch>
                            <Route path="/Dashboards"><DashboardsEfecto /></Route>   
                                             
                            <Route path="/Inicio"><Inicio /></Route>                           
                            <Route path="/Logout"><Logout /></Route>                         
                                               
                        </switch>
                    </Typography>
                </main>
            </div>
        </Router >
    );
}

